export const CHECKOUT_URLS = {
  primaria:
    'https://docente360.com.ar/checkouts/cn/hWNDjKae6Sq1n3Ylq5YpBNFi/en-ar?_r=AQABrItxnAWoCVMOw_p3dGkp3TPUOATk99h3UldAiJ6HX0U&ra=2',
  secundaria:
    'https://docente360.com.ar/checkouts/cn/hWNDjKaDYGHLUZqW8bUlUXOk/en-ar?_r=AQABqjLQh0-ObrAOz_XkiwbldJhCXflJoMqwB5DGFJ_cy40',
  megapack:
    'https://docente360.com.ar/checkouts/cn/hWNDjKaREJ84o1CkXnAjtyAE/en-ar?_r=AQABaJTXDyJyB2mlmY6EtPxrcJ4n-JUWIywrbK2zhSN6XWM',
}
